import React from "react";
import {PropTypes} from "prop-types";
import DynamicImage from "../../../General/components/DynamicImage/DynamicImage";

export const getYTUrl = (videoId) => `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;
const BlogImage = ({width, height, image, youtubeVideo, ...props}) =>
    youtubeVideo ? (
        <img {...props} alt={""} src={getYTUrl(youtubeVideo)} />
    ) : (
        <DynamicImage
            {...props}
            options={{
                width,
                height,
                smart: true,
            }}
            alt={""}
            src={image}
        />
    );

BlogImage.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    image: PropTypes.string,
    youtubeVideo: PropTypes.string,
};

BlogImage.defaultProps = {
    width: 0,
    height: 0,
};

export default BlogImage;
